import { instance } from 'Services/instance'
import Const from 'Utils/Consts'
import VisitsApiPaths from '../Constants/VisitsApiPaths'
import gregorianDate from 'Utils/gregorianDate'
import { addVisit, deleteVisit, getAllVisit, getVisitById, updateVisit } from 'DataBase/VisitsDB'
import type { INewVisitModel } from './model'

export async function setVisit(
  newVisit: INewVisitModel,
  withClearImages: boolean = false,
): Promise<Date> {
  const visit = {
    visitLocalId: newVisit.visitLocalId,
    draftVisitId: newVisit.draftVisitId,
    createTime: newVisit.createTime,
    lastChangeTime: newVisit.lastChangeTime,
    isSaved: true,
    hasError: newVisit.hasError,
    saveWithoutNet: newVisit.saveWithoutNet,
    storeFileType: newVisit.storeFileType,
    visitId: newVisit.visitId,
    visitStatus: newVisit.visitStatus,
    customerInfo: {
      civilRegistryConfirmationLoaded: newVisit.customerInfo.civilRegistryConfirmationLoaded,
      validateLegalCustomerSuccess: newVisit.customerInfo.validateLegalCustomerSuccess,
      validateLegalCustomerData: newVisit.customerInfo.validateLegalCustomerData,
      personType: newVisit.customerInfo.personType,
      isDeath: newVisit.customerInfo.isDeath,
      firstName: newVisit.customerInfo.firstName,
      lastName: newVisit.customerInfo.lastName,
      identityCode: newVisit.customerInfo.identityCode,
      birthDate: newVisit.customerInfo.birthDate,
      gender: newVisit.customerInfo.gender,
      mobilePhoneNumber: newVisit.customerInfo.mobilePhoneNumber,
      visitLocationType: newVisit.customerInfo.visitLocationType,
      stateId: newVisit.customerInfo.stateId,
      cityId: newVisit.customerInfo.cityId,
      location: newVisit.customerInfo.location,
      branchCode: newVisit.customerInfo.branchCode,
      nationalityID: newVisit.customerInfo.nationalityID,
    },
    uploadLink: {
      loading: false,
      loaded: newVisit.uploadLink?.loaded,
      lastLinkGetTime: newVisit.uploadLink?.lastLinkGetTime,
      link: newVisit.uploadLink?.link,
    },
    customerDeliberately: {
      // loading: newVisit.customerDeliberately.loading,
      loading: false,
      nationalCard: newVisit.customerDeliberately.nationalCard
        ? {
          id: newVisit.customerDeliberately.nationalCard.id,
          name: newVisit.customerDeliberately.nationalCard.name,
          image:
            newVisit.customerDeliberately.nationalCard.status == 1
              ? ''
              : newVisit.customerDeliberately.nationalCard.image,
          fileType: newVisit.customerDeliberately.nationalCard.fileType,
          price: newVisit.customerDeliberately.nationalCard.price,
          description: newVisit.customerDeliberately.nationalCard.description,
          uploadProgress: newVisit.customerDeliberately.nationalCard.uploadProgress,
          fileId: newVisit.customerDeliberately.nationalCard.fileId,
          hashFile: newVisit.customerDeliberately.nationalCard.hashFile,
          hashFileType: newVisit.customerDeliberately.nationalCard.hashFileType,
          hashFileExtension: newVisit.customerDeliberately.nationalCard.hashFileExtension,
          hashFileSize: newVisit.customerDeliberately.nationalCard.hashFileSize,
          status: newVisit.customerDeliberately.nationalCard.status,
          cancelToken: newVisit.customerDeliberately.nationalCard.cancelToken,
        }
        : undefined,
      nationalCardBack: newVisit.customerDeliberately.nationalCardBack
        ? {
          id: newVisit.customerDeliberately.nationalCardBack.id,
          name: newVisit.customerDeliberately.nationalCardBack.name,
          image:
            newVisit.customerDeliberately.nationalCardBack.status == 1
              ? ''
              : newVisit.customerDeliberately.nationalCardBack.image,
          fileType: newVisit.customerDeliberately.nationalCardBack.fileType,
          price: newVisit.customerDeliberately.nationalCardBack.price,
          description: newVisit.customerDeliberately.nationalCardBack.description,
          uploadProgress: newVisit.customerDeliberately.nationalCardBack.uploadProgress,
          fileId: newVisit.customerDeliberately.nationalCardBack.fileId,
          hashFile: newVisit.customerDeliberately.nationalCardBack.hashFile,
          hashFileType: newVisit.customerDeliberately.nationalCardBack.hashFileType,
          hashFileExtension: newVisit.customerDeliberately.nationalCardBack.hashFileExtension,
          hashFileSize: newVisit.customerDeliberately.nationalCardBack.hashFileSize,
          status: newVisit.customerDeliberately.nationalCardBack.status,
          cancelToken: newVisit.customerDeliberately.nationalCardBack.cancelToken,
        }
        : undefined,
      vehicleDeliberatelyType: newVisit.customerDeliberately.vehicleDeliberatelyType,
      vehicleCard: newVisit.customerDeliberately.vehicleCard
        ? {
          id: newVisit.customerDeliberately.vehicleCard.id,
          name: newVisit.customerDeliberately.vehicleCard.name,
          image:
            newVisit.customerDeliberately.vehicleCard.status == 1
              ? ''
              : newVisit.customerDeliberately.vehicleCard.image,
          fileType: newVisit.customerDeliberately.vehicleCard.fileType,
          price: newVisit.customerDeliberately.vehicleCard.price,
          description: newVisit.customerDeliberately.vehicleCard.description,
          uploadProgress: newVisit.customerDeliberately.vehicleCard.uploadProgress,
          fileId: newVisit.customerDeliberately.vehicleCard.fileId,
          hashFile: newVisit.customerDeliberately.vehicleCard.hashFile,
          hashFileType: newVisit.customerDeliberately.vehicleCard.hashFileType,
          hashFileExtension: newVisit.customerDeliberately.vehicleCard.hashFileExtension,
          hashFileSize: newVisit.customerDeliberately.vehicleCard.hashFileSize,
          status: newVisit.customerDeliberately.vehicleCard.status,
          cancelToken: newVisit.customerDeliberately.vehicleCard.cancelToken,
        }
        : undefined,
      vehicleCardBack: newVisit.customerDeliberately.vehicleCardBack
        ? {
          id: newVisit.customerDeliberately.vehicleCardBack.id,
          name: newVisit.customerDeliberately.vehicleCardBack.name,
          image:
            newVisit.customerDeliberately.vehicleCardBack.status == 1
              ? ''
              : newVisit.customerDeliberately.vehicleCardBack.image,
          fileType: newVisit.customerDeliberately.vehicleCardBack.fileType,
          price: newVisit.customerDeliberately.vehicleCardBack.price,
          description: newVisit.customerDeliberately.vehicleCardBack.description,
          uploadProgress: newVisit.customerDeliberately.vehicleCardBack.uploadProgress,
          fileId: newVisit.customerDeliberately.vehicleCardBack.fileId,
          hashFile: newVisit.customerDeliberately.vehicleCardBack.hashFile,
          hashFileType: newVisit.customerDeliberately.vehicleCardBack.hashFileType,
          hashFileExtension: newVisit.customerDeliberately.vehicleCardBack.hashFileExtension,
          hashFileSize: newVisit.customerDeliberately.vehicleCardBack.hashFileSize,
          status: newVisit.customerDeliberately.vehicleCardBack.status,
          cancelToken: newVisit.customerDeliberately.vehicleCardBack.cancelToken,
        }
        : undefined,
      vehicleDoc: newVisit.customerDeliberately.vehicleDoc
        ? {
          id: newVisit.customerDeliberately.vehicleDoc.id,
          name: newVisit.customerDeliberately.vehicleDoc.name,
          image:
            newVisit.customerDeliberately.vehicleDoc.status == 1
              ? ''
              : newVisit.customerDeliberately.vehicleDoc.image,
          fileType: newVisit.customerDeliberately.vehicleDoc.fileType,
          price: newVisit.customerDeliberately.vehicleDoc.price,
          description: newVisit.customerDeliberately.vehicleDoc.description,
          uploadProgress: newVisit.customerDeliberately.vehicleDoc.uploadProgress,
          fileId: newVisit.customerDeliberately.vehicleDoc.fileId,
          hashFile: newVisit.customerDeliberately.vehicleDoc.hashFile,
          hashFileType: newVisit.customerDeliberately.vehicleDoc.hashFileType,
          hashFileExtension: newVisit.customerDeliberately.vehicleDoc.hashFileExtension,
          hashFileSize: newVisit.customerDeliberately.vehicleDoc.hashFileSize,
          status: newVisit.customerDeliberately.vehicleDoc.status,
          cancelToken: newVisit.customerDeliberately.vehicleDoc.cancelToken,
        }
        : undefined,
      vehicleCompanyDoc: newVisit.customerDeliberately.vehicleCompanyDoc
        ? {
          id: newVisit.customerDeliberately.vehicleCompanyDoc.id,
          name: newVisit.customerDeliberately.vehicleCompanyDoc.name,
          image:
            newVisit.customerDeliberately.vehicleCompanyDoc.status == 1
              ? ''
              : newVisit.customerDeliberately.vehicleCompanyDoc.image,
          fileType: newVisit.customerDeliberately.vehicleCompanyDoc.fileType,
          price: newVisit.customerDeliberately.vehicleCompanyDoc.price,
          description: newVisit.customerDeliberately.vehicleCompanyDoc.description,
          uploadProgress: newVisit.customerDeliberately.vehicleCompanyDoc.uploadProgress,
          fileId: newVisit.customerDeliberately.vehicleCompanyDoc.fileId,
          hashFile: newVisit.customerDeliberately.vehicleCompanyDoc.hashFile,
          hashFileType: newVisit.customerDeliberately.vehicleCompanyDoc.hashFileType,
          hashFileExtension: newVisit.customerDeliberately.vehicleCompanyDoc.hashFileExtension,
          hashFileSize: newVisit.customerDeliberately.vehicleCompanyDoc.hashFileSize,
          status: newVisit.customerDeliberately.vehicleCompanyDoc.status,
          cancelToken: newVisit.customerDeliberately.vehicleCompanyDoc.cancelToken,
        }
        : undefined,
    },
    carInfo: {
      plate: newVisit.carInfo?.plate,
      vehicleTypeId: newVisit.carInfo?.vehicleTypeId,
      hasTrailer: newVisit.carInfo?.hasTrailer,
      vehicleBrandId: newVisit.carInfo?.vehicleBrandId,
      vehicleTipId: newVisit.carInfo?.vehicleTipId,
      cargoCompartmentId: newVisit.carInfo?.cargoCompartmentId,
      vehicleColorId: newVisit.carInfo?.vehicleColorId,
      vehicleUsageId: newVisit.carInfo?.vehicleUsageId,
      vehicleStatus: newVisit.carInfo?.vehicleStatus,
      numberOfCylinders: newVisit.carInfo?.numberOfCylinders,
      yearOfConstruction: newVisit.carInfo?.yearOfConstruction,
      vehicleMileage: newVisit.carInfo?.vehicleMileage,
      chassisNumber: newVisit.carInfo?.chassisNumber,
      engineNumber: newVisit.carInfo?.engineNumber,
      VIN: newVisit.carInfo?.VIN,
    },
    vehicleVisitingPoints: {
      data: withClearImages
        ? []
        : newVisit.vehicleVisitingPoints.data.map(x => {
          return {
            id: x.id,
            name: x.name,
            image: x.status == 1 ? '' : x.image,
            fileType: x.fileType,
            price: x.price,
            description: x.description,
            uploadProgress: x.uploadProgress,
            fileId: x.fileId,
            hashFile: x.hashFile,
            hashFileType: x.hashFileType,
            hashFileExtension: x.hashFileExtension,
            hashFileSize: x.hashFileSize,
            status: x.status,
            cancelToken: x.cancelToken,
            isPlatePhotoAvailable: x.isPlatePhotoAvailable,
          }
        }),
      currentImage: withClearImages ? 0 : newVisit.vehicleVisitingPoints.currentImage,
      mode: withClearImages ? 'Image' : newVisit.vehicleVisitingPoints.mode,
      // loading: newVisit.vehicleVisitingPoints.loading,
      loading: false,
      // recordedChunks: newVisit.vehicleVisitingPoints.videoStatus == 1 ? [] : newVisit.vehicleVisitingPoints.recordedChunks,
      videoRecorded: withClearImages ? [] : newVisit.vehicleVisitingPoints.videoRecorded,
      // videoLoading: newVisit.vehicleVisitingPoints.videoLoading,
      videoLoading: false,
      videoUploadProgress: withClearImages ? 0 : newVisit.vehicleVisitingPoints.videoUploadProgress,
      videoFileId: withClearImages ? undefined : newVisit.vehicleVisitingPoints.videoFileId,
      videoHashFile: withClearImages ? undefined : newVisit.vehicleVisitingPoints.videoHashFile,
      videoHashFileType: withClearImages
        ? undefined
        : newVisit.vehicleVisitingPoints.videoHashFileType,
      videoHashFileExtension: withClearImages
        ? undefined
        : newVisit.vehicleVisitingPoints.videoHashFileExtension,
      videoHashFileSize: withClearImages
        ? undefined
        : newVisit.vehicleVisitingPoints.videoHashFileSize,
      videoStatus: withClearImages ? 0 : newVisit.vehicleVisitingPoints.videoStatus,
      videoCancelToken: withClearImages ? '' : newVisit.vehicleVisitingPoints.videoCancelToken,
      skipVideo: withClearImages ? false : newVisit.vehicleVisitingPoints.skipVideo,
    },
    notHealthyAutoParts: {
      data: newVisit.notHealthyAutoParts.data.map(x => {
        return {
          id: x.id,
          name: x.name,
          image: x.status == 1 ? '' : x.image,
          fileType: x.fileType,
          price: x.price,
          description: x.description,
          uploadProgress: x.uploadProgress,
          fileId: x.fileId,
          hashFile: x.hashFile,
          hashFileType: x.hashFileType,
          hashFileExtension: x.hashFileExtension,
          hashFileSize: x.hashFileSize,
          status: x.status,
          cancelToken: x.cancelToken,
        }
      }),
      // loading: newVisit.notHealthyAutoParts.loading
      loading: false,
    },
    vehicleAccessories: {
      data: newVisit.vehicleAccessories.data.map(x => {
        return {
          id: x.id,
          name: x.name,
          image: x.status == 1 ? '' : x.image,
          fileType: x.fileType,
          price: x.price,
          description: x.description,
          uploadProgress: x.uploadProgress,
          fileId: x.fileId,
          hashFile: x.hashFile,
          hashFileType: x.hashFileType,
          hashFileExtension: x.hashFileExtension,
          hashFileSize: x.hashFileSize,
          status: x.status,
          cancelToken: x.cancelToken,
        }
      }),
      // loading: newVisit.vehicleAccessories.loading
      loading: false,
    },
    vehicleOptions: newVisit.vehicleOptions.map(x => {
      return {
        vehicleOptionId: x.vehicleOptionId,
        vehicleOptionDetailId: x.vehicleOptionDetailId,
      }
    }),
    prices: {
      // loading: newVisit.prices.loading,
      loading: false,
      loaded: newVisit.prices?.loaded,
      price: newVisit.prices?.price,
      towingValue: newVisit.prices?.towingValue,
    },
    coverages: {
      mainBodyInsuranceCoverageId: newVisit.coverages?.mainBodyInsuranceCoverageId,
      // additionalBodyInsuranceCoverageId: newVisit.coverages.additionalBodyInsuranceCoverageId,
      // loading: newVisit.coverages.loading,
      loading: false,
      loaded: newVisit.coverages?.loaded,
      estimatedPriceOfBodyInsurance: newVisit.coverages?.estimatedPriceOfBodyInsurance,
    },
    description: newVisit.description,
    // loading: newVisit.loading
    loading: false,
  }

  if (newVisit.isSaved) {
    visit.lastChangeTime = new Date()
    if (
      newVisit.vehicleVisitingPoints.videoStatus == 1 ||
      !newVisit.vehicleVisitingPoints.recordedChunks ||
      newVisit.vehicleVisitingPoints.recordedChunks?.length == 0
    ) {
      visit.vehicleVisitingPoints.videoStatus = 1
      await updateVisit(Number(visit.visitLocalId), JSON.stringify(visit), '')
    } else {
      await blobsToBase64JsonString(newVisit.vehicleVisitingPoints.recordedChunks).then(
        async video => {
          await updateVisit(Number(visit.visitLocalId), JSON.stringify(visit), video)
        },
      )
    }
  } else {
    visit.lastChangeTime = new Date()
    if (
      newVisit.vehicleVisitingPoints.videoStatus == 1 ||
      !newVisit.vehicleVisitingPoints.recordedChunks ||
      newVisit.vehicleVisitingPoints.recordedChunks?.length == 0
    ) {
      visit.vehicleVisitingPoints.videoStatus = 1
      await addVisit(Number(visit.visitLocalId), JSON.stringify(visit), '')
    } else {
      await blobsToBase64JsonString(newVisit.vehicleVisitingPoints.recordedChunks).then(
        async video => {
          await addVisit(Number(visit.visitLocalId), JSON.stringify(visit), video)
        },
      )
    }
  }
  return visit.lastChangeTime
}

export async function blobsToBase64JsonString(blobs: Blob[]): Promise<string> {
  const data = await Promise.all(
    blobs.map(
      blob =>
        new Promise<{ base64: string; type: string }>((resolve, reject) => {
          const reader = new FileReader()
          reader.onloadend = () => {
            const result = reader.result as string
            resolve({ base64: result, type: blob.type })
          }
          reader.onerror = reject
          reader.readAsDataURL(blob)
        }),
    ),
  )

  return JSON.stringify(data)
}
export function base64JsonStringToBlobs(jsonString: string): Blob[] {
  const data: { base64: string; type: string }[] = JSON.parse(jsonString)

  return data.map(({ base64, type }) => {
    const base64Data = base64.includes('base64,') ? base64.split('base64,')[1] : base64
    if (!base64Data || typeof base64Data !== 'string') {
      throw new Error('Invalid base64 data')
    }

    const cleaned = base64Data.replace(/[^A-Za-z0-9+/=]/g, '')

    const byteCharacters = atob(cleaned)
    const byteNumbers = new Array(byteCharacters.length)

    for (let i = 0; i < byteCharacters.length; i++) {
      byteNumbers[i] = byteCharacters.charCodeAt(i)
    }

    const byteArray = new Uint8Array(byteNumbers)
    return new Blob([byteArray], { type })
  })
}

export async function getVisits(): Promise<INewVisitModel[] | undefined> {
  let visitsList: INewVisitModel[] = []

  var visits = await getAllVisit()
  if (visits) {
    visits.forEach(visit => {
      var tempVisit = JSON.parse(visit.data)
      if (visit.video && tempVisit.vehicleVisitingPoints) {
        var video = base64JsonStringToBlobs(visit.video)
        tempVisit.vehicleVisitingPoints.recordedChunks = video
      }
      visitsList.push(tempVisit)
      // visitsList.push(JSON.parse(visit.data))
    })
    return visitsList
  }

  return undefined
}

export async function getVisit(visitLocalId: number): Promise<INewVisitModel | undefined> {
  var visit = await getVisitById(visitLocalId)
  if (visit) {
    // return JSON.parse(visit.data)
    var tempVisit = JSON.parse(visit.data)
    if (visit.video && tempVisit.vehicleVisitingPoints) {
      var video = base64JsonStringToBlobs(visit.video)
      tempVisit.vehicleVisitingPoints.recordedChunks = video
    }
    return tempVisit
  }

  return undefined
}

export async function removeVisit(visitLocalId: number) {
  await deleteVisit(visitLocalId)
}

export async function persistTempVisit() {
  var visitsList = await getVisits()

  if (visitsList) {
    const nowTime = new Date().getTime()
    var expireVisits = visitsList.filter(
      x =>
        x.saveWithoutNet == false &&
        nowTime - new Date(String(x.lastChangeTime)).getTime() >
        Const.env.REACT_APP_VISIT_EXPIRE_TIME_IN_SECONDS * 1000,
    )

    if (expireVisits.length > 0) {
      var data = {
        visits: expireVisits.map(item => {
          return {
            visitDate: gregorianDate(new Date(String(item.createTime))),
            draftVisitId: item.draftVisitId ?? null,
            visitStatus: item.visitStatus,
            lastChangeDate: gregorianDate(new Date(String(item.lastChangeTime))),
            cityId: item.customerInfo?.visitLocationType == 1 ? item.customerInfo.cityId : null,
            insuranceTypeId: 984,
            issuanceReasonVisitId: 43,
            firstName: item.customerInfo.firstName ? item.customerInfo.firstName : null,
            lastName: item.customerInfo.lastName ? item.customerInfo.lastName : null,
            identityCode: item.customerInfo.identityCode ? item.customerInfo.identityCode : null,
            birthDate: item.customerInfo.birthDate ? item.customerInfo.birthDate : null,
            mobilePhoneNumber: item.customerInfo.mobilePhoneNumber
              ? item.customerInfo.mobilePhoneNumber
              : null,
            plateType: item.carInfo.plate?.type == 'CAR' ? 1 : 2,
            plateCityCode: item.carInfo.plate?.cityCode ? item.carInfo.plate?.cityCode : null,
            plateChar: item.carInfo.plate?.char ? item.carInfo.plate?.char : null,
            plateCarSerial: item.carInfo.plate?.carSerial ? item.carInfo.plate?.carSerial : null,
            plateMotorCycleSerial: item.carInfo.plate?.motorCycleSerial
              ? item.carInfo.plate?.motorCycleSerial
              : null,
            plateCarOtherNumber: item.carInfo.plate?.carOtherNumber
              ? item.carInfo.plate?.carOtherNumber
              : null,
            plateAdditionalNumber: item.carInfo.plate?.motorCycleOtherNumber
              ? item.carInfo.plate?.motorCycleOtherNumber
              : null,
            vehicleTypeId: item.carInfo.vehicleTypeId ? item.carInfo.vehicleTypeId : null,
            cargoCompartmentId: item.carInfo.cargoCompartmentId ?? null,
            vehicleBrandId: item.carInfo.vehicleBrandId ? item.carInfo.vehicleBrandId : null,
            vehicleTipId: item.carInfo.vehicleTipId ? item.carInfo.vehicleTipId : null,
            vehicleColorId: item.carInfo.vehicleColorId ? item.carInfo.vehicleColorId : null,
            vehicleUsageId: item.carInfo.vehicleUsageId ? item.carInfo.vehicleUsageId : null,
            vehicleStatus: item.carInfo.vehicleStatus
              ? Number(item.carInfo.vehicleStatus) - 1
              : null,
            numberOfCylinders: item.carInfo.numberOfCylinders
              ? item.carInfo.numberOfCylinders
              : null,
            yearOfConstruction: item.carInfo.yearOfConstruction
              ? item.carInfo.yearOfConstruction
              : null,
            vehicleMileage: Number(String(item.carInfo.vehicleMileage).replace(/,/g, ''))
              ? Number(String(item.carInfo.vehicleMileage).replace(/,/g, ''))
              : null,
            price: item.prices.price ? item.prices.price : null,
            description: item.description ? item.description : null,

            videoId:
              item.storeFileType == 'POD_SPACE' ? null : item.vehicleVisitingPoints.videoFileId,
            videoHashFile:
              item.storeFileType == 'POD_SPACE' ? item.vehicleVisitingPoints.videoHashFile : null,
            videoHashFileType:
              item.storeFileType == 'POD_SPACE'
                ? item.vehicleVisitingPoints.videoHashFileType
                : null,
            videoHashFileExtension:
              item.storeFileType == 'POD_SPACE'
                ? item.vehicleVisitingPoints.videoHashFileExtension
                : null,
            videoHashFileSize:
              item.storeFileType == 'POD_SPACE'
                ? item.vehicleVisitingPoints.videoHashFileSize
                : null,
            nationalCardId:
              item.storeFileType == 'POD_SPACE'
                ? null
                : item.customerDeliberately.nationalCard?.fileId,
            nationalCardHashFile:
              item.storeFileType == 'POD_SPACE'
                ? item.customerDeliberately.nationalCard?.hashFile
                : null,
            nationalCardHashFileType:
              item.storeFileType == 'POD_SPACE'
                ? item.customerDeliberately.nationalCard?.hashFileType
                : null,
            nationalCardHashFileExtension:
              item.storeFileType == 'POD_SPACE'
                ? item.customerDeliberately.nationalCard?.hashFileExtension
                : null,
            nationalCardHashFileSize:
              item.storeFileType == 'POD_SPACE'
                ? item.customerDeliberately.nationalCard?.hashFileSize
                : null,
            nationalCardBackId:
              item.storeFileType == 'POD_SPACE'
                ? null
                : item.customerDeliberately.nationalCardBack?.fileId,
            nationalCardBackHashFile:
              item.storeFileType == 'POD_SPACE'
                ? item.customerDeliberately.nationalCardBack?.hashFile
                : null,
            nationalCardBackHashFileType:
              item.storeFileType == 'POD_SPACE'
                ? item.customerDeliberately.nationalCardBack?.hashFileType
                : null,
            nationalCardBackHashFileExtension:
              item.storeFileType == 'POD_SPACE'
                ? item.customerDeliberately.nationalCardBack?.hashFileExtension
                : null,
            nationalCardBackHashFileSize:
              item.storeFileType == 'POD_SPACE'
                ? item.customerDeliberately.nationalCardBack?.hashFileSize
                : null,
            vehicleDeliberatelyType:
              item.customerDeliberately.vehicleDeliberatelyType == 'CARD'
                ? 1
                : item.customerDeliberately.vehicleDeliberatelyType == 'DOC'
                  ? 2
                  : 3,
            vehicleCardId:
              item.storeFileType == 'POD_SPACE'
                ? null
                : item.customerDeliberately.vehicleDeliberatelyType == 'CARD'
                  ? item.customerDeliberately.vehicleCard?.fileId
                  : null,
            vehicleCardHashFile:
              item.storeFileType == 'POD_SPACE'
                ? item.customerDeliberately.vehicleDeliberatelyType == 'CARD'
                  ? item.customerDeliberately.vehicleCard?.hashFile
                  : null
                : null,
            vehicleCardHashFileType:
              item.storeFileType == 'POD_SPACE'
                ? item.customerDeliberately.vehicleDeliberatelyType == 'CARD'
                  ? item.customerDeliberately.vehicleCard?.hashFileType
                  : null
                : null,
            vehicleCardHashFileExtension:
              item.storeFileType == 'POD_SPACE'
                ? item.customerDeliberately.vehicleDeliberatelyType == 'CARD'
                  ? item.customerDeliberately.vehicleCard?.hashFileExtension
                  : null
                : null,
            vehicleCardHashFileSize:
              item.storeFileType == 'POD_SPACE'
                ? item.customerDeliberately.vehicleDeliberatelyType == 'CARD'
                  ? item.customerDeliberately.vehicleCard?.hashFileSize
                  : null
                : null,
            vehicleCardBackId:
              item.storeFileType == 'POD_SPACE'
                ? null
                : item.customerDeliberately.vehicleDeliberatelyType == 'CARD'
                  ? item.customerDeliberately.vehicleCardBack?.fileId
                  : null,
            vehicleCardBackHashFile:
              item.storeFileType == 'POD_SPACE'
                ? item.customerDeliberately.vehicleDeliberatelyType == 'CARD'
                  ? item.customerDeliberately.vehicleCardBack?.hashFile
                  : null
                : null,
            vehicleCardBackHashFileType:
              item.storeFileType == 'POD_SPACE'
                ? item.customerDeliberately.vehicleDeliberatelyType == 'CARD'
                  ? item.customerDeliberately.vehicleCardBack?.hashFileType
                  : null
                : null,
            vehicleCardBackHashFileExtension:
              item.storeFileType == 'POD_SPACE'
                ? item.customerDeliberately.vehicleDeliberatelyType == 'CARD'
                  ? item.customerDeliberately.vehicleCardBack?.hashFileExtension
                  : null
                : null,
            vehicleCardBackHashFileSize:
              item.storeFileType == 'POD_SPACE'
                ? item.customerDeliberately.vehicleDeliberatelyType == 'CARD'
                  ? item.customerDeliberately.vehicleCardBack?.hashFileSize
                  : null
                : null,
            vehicleDocId:
              item.storeFileType == 'POD_SPACE'
                ? null
                : item.customerDeliberately.vehicleDeliberatelyType == 'DOC'
                  ? item.customerDeliberately.vehicleDoc?.fileId
                  : null,
            vehicleDocHashFile:
              item.storeFileType == 'POD_SPACE'
                ? item.customerDeliberately.vehicleDeliberatelyType == 'DOC'
                  ? item.customerDeliberately.vehicleDoc?.hashFile
                  : null
                : null,
            vehicleDocHashFileType:
              item.storeFileType == 'POD_SPACE'
                ? item.customerDeliberately.vehicleDeliberatelyType == 'DOC'
                  ? item.customerDeliberately.vehicleDoc?.hashFileType
                  : null
                : null,
            vehicleDocHashFileExtension:
              item.storeFileType == 'POD_SPACE'
                ? item.customerDeliberately.vehicleDeliberatelyType == 'DOC'
                  ? item.customerDeliberately.vehicleDoc?.hashFileExtension
                  : null
                : null,
            vehicleDocHashFileSize:
              item.storeFileType == 'POD_SPACE'
                ? item.customerDeliberately.vehicleDeliberatelyType == 'DOC'
                  ? item.customerDeliberately.vehicleDoc?.hashFileSize
                  : null
                : null,
            vehicleCompanyDocId:
              item.storeFileType == 'POD_SPACE'
                ? null
                : item.customerDeliberately.vehicleDeliberatelyType == 'COMPANY_DOC'
                  ? item.customerDeliberately.vehicleCompanyDoc?.fileId
                  : null,
            vehicleCompanyDocHashFile:
              item.storeFileType == 'POD_SPACE'
                ? item.customerDeliberately.vehicleDeliberatelyType == 'COMPANY_DOC'
                  ? item.customerDeliberately.vehicleCompanyDoc?.hashFile
                  : null
                : null,
            vehicleCompanyDocHashFileType:
              item.storeFileType == 'POD_SPACE'
                ? item.customerDeliberately.vehicleDeliberatelyType == 'COMPANY_DOC'
                  ? item.customerDeliberately.vehicleCompanyDoc?.hashFileType
                  : null
                : null,
            vehicleCompanyDocHashFileExtension:
              item.storeFileType == 'POD_SPACE'
                ? item.customerDeliberately.vehicleDeliberatelyType == 'COMPANY_DOC'
                  ? item.customerDeliberately.vehicleCompanyDoc?.hashFileExtension
                  : null
                : null,
            vehicleCompanyDocHashFileSize:
              item.storeFileType == 'POD_SPACE'
                ? item.customerDeliberately.vehicleDeliberatelyType == 'COMPANY_DOC'
                  ? item.customerDeliberately.vehicleCompanyDoc?.hashFileSize
                  : null
                : null,

            dispatchLocation:
              item.customerInfo?.visitLocationType == 1
                ? item.customerInfo.location?.address
                : null,
            chassisNumber: item.carInfo.chassisNumber ? item.carInfo.chassisNumber : null,
            engineNumber: item.carInfo.engineNumber ? item.carInfo.engineNumber : null,
            vin: item.carInfo.VIN ? item.carInfo.VIN : null,
            visitDeadline: 0,
            towingValue: item.prices.towingValue ? item.prices.towingValue : null,
            personType: item.customerInfo.personType,
            branchCode: item.customerInfo.branchCode,
            nationalityID: item.customerInfo.nationalityID,
            gender: item.customerInfo.gender ? item.customerInfo.gender : null,
            birthPlace: 'AAAAAA',
            placeOfIssue: 'AAAAAA',
            fatherName: 'AAAAA',
            isPodSpaceEnable: item.storeFileType == 'POD_SPACE',
            expertUnitId: null,
            expertId: null,
            vehicleExpertiseTitle: null,
            countryId: null,
            address:
              item.customerInfo?.visitLocationType == 1
                ? item.customerInfo.location?.address
                : 'در محل واحد صدور',
            mainBodyInsuranceCoverageId: null,
            maritalStatus: 1,
            temporaryVisitVehicleOptionDetailIds: item.vehicleOptions.map(x => {
              return x.vehicleOptionDetailId
            }),
            temporaryVisitVehicleVisitingPoints: item.vehicleVisitingPoints.data.map(x => {
              return {
                vehicleVisitingPointId: x.id,
                visitFileId: item.storeFileType == 'POD_SPACE' ? null : x.fileId,
                visitHashFile: item.storeFileType == 'POD_SPACE' ? x.hashFile : null,
                visitHashFileExtension:
                  item.storeFileType == 'POD_SPACE' ? x.hashFileExtension : null,
                visitHashFileType: item.storeFileType == 'POD_SPACE' ? x.hashFileType : null,
                visitHashFileSize: item.storeFileType == 'POD_SPACE' ? x.hashFileSize : null,
                description: '',
              }
            }),
            temporaryVisitAutoParts: item.notHealthyAutoParts.data.map(x => {
              return {
                autoPartId: x.id,
                visitFileId: item.storeFileType == 'POD_SPACE' ? null : x.fileId,
                visitHashFile: item.storeFileType == 'POD_SPACE' ? x.hashFile : null,
                visitHashFileExtension:
                  item.storeFileType == 'POD_SPACE' ? x.hashFileExtension : null,
                visitHashFileType: item.storeFileType == 'POD_SPACE' ? x.hashFileType : null,
                visitHashFileSize: item.storeFileType == 'POD_SPACE' ? x.hashFileSize : null,
                isHealthy: false,
                description: x.description,
                damagePercent: 0,
                amountOfDamages: 0,
              }
            }),
            temporaryVisitVehicleAccessories: item.vehicleAccessories.data.map(x => {
              return {
                vehicleAccessoryId: x.id,
                visitFileId: item.storeFileType == 'POD_SPACE' ? null : x.fileId,
                visitHashFile: item.storeFileType == 'POD_SPACE' ? x.hashFile : null,
                visitHashFileExtension:
                  item.storeFileType == 'POD_SPACE' ? x.hashFileExtension : null,
                visitHashFileType: item.storeFileType == 'POD_SPACE' ? x.hashFileType : null,
                visitHashFileSize: item.storeFileType == 'POD_SPACE' ? x.hashFileSize : null,
                accessoryValue: x.price,
                description: x.description,
              }
            }),

            // visitLocationType: item.customerInfo?.visitLocationType,
            // latitude: item.customerInfo?.visitLocationType == 1 ? item.customerInfo.location?.latitude : null,
            // longitude: item.customerInfo?.visitLocationType == 1 ? item.customerInfo.location?.longitude : null,
            // checkCivilRegistry: false,
          }
        }),
      }

      await instance
        .post(VisitsApiPaths.CreateTemporaryVisits, data, { timeout: 60000 })
        .then(res => {
          if (res.status === 200 || res.status === 201) {
            expireVisits.map(async item => {
              await deleteVisit(Number(item.visitLocalId))
            })
          }
        })
        .catch(error => { })
    }
  }
}
